import { Icon } from '@eti/components';
import { css, etiColors, mediaQueries } from '@eti/styles';
import PropTypes from 'prop-types';

const buttonBorder = `1px solid ${etiColors.grayScale[6]}`;
const buttonBoxShadow = `0 0 5px rgba(0, 0, 0, 0.2)`;

const boundExpansionsButtonsStyle = (isExpanded, isVI) => css`
  border: ${isExpanded ? 'none' : buttonBorder};
  border-radius: 12px;
  box-shadow: ${isExpanded ? 'none' : buttonBoxShadow};
  cursor: pointer;
  display: flex;
  flex-direction: column;
  height: ${isExpanded ? 'calc(100% - 127px)' : 'auto'};
  margin-top: ${isExpanded ? '77px' : 0};
  position: absolute;
  right: 10px;
  top: ${isExpanded ? '0' : `calc(50% - ${isVI ? 64 : 34}px / 2)`};

  [dir='rtl'] & {
    left: 10px;
    right: auto;
  }

  @media ${mediaQueries.large.up} {
    right: 20px;
    top: ${isExpanded ? '0' : `calc(50% - ${isVI ? 82 : 50}px / 2)`};

    [dir='rtl'] & {
      left: 20px;
      right: auto;
    }
  }
`;

const boundExpansionButtonsLineStyle = (isExpanded) => css`
  background-color: #000;
  height: 100%;
  margin: 0 auto;
  opacity: ${isExpanded ? 0.1 : 0};
  transition: opacity 0.2s;
  width: 4px;

  @media ${mediaQueries.large.up} {
    width: 5px;
  }
`;

const arrowContainerStyle = (direction, isExpanded) => css`
  align-items: center;
  background-color: #fff;
  border: ${isExpanded ? buttonBorder : 'none'};
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
  border-top: ${buttonBorder};
  box-shadow: ${isExpanded ? buttonBoxShadow : 'none'};
  display: flex;
  height: 16px;
  margin-top: ${direction !== 'up' ? '-1px' : 0};
  padding: 3px;
  transform: rotate(${direction === 'up' ? '180' : '0'}deg);
  width: 16px;

  @media ${mediaQueries.large.up} {
    [dir='rtl'] & {
      left: 20px;
      right: auto;
    }

    height: 24px;
    width: 24px;
  }
`;

const arrowIconStyle = (isExpanded) => css`
  height: 100%;
  margin-top: ${isExpanded ? '-3px' : 0};
  transform: rotate(${isExpanded ? '180' : '0'}deg);
  transition: transform 0.2s;
  width: 100%;

  @media ${mediaQueries.large.up} {
    height: 10px;
  }
`;

const TripDetailsExpansionButtons = ({ isExpanded, isVI }) => (
  <div
    className={boundExpansionsButtonsStyle(isExpanded, isVI)}
    data-testid="searchResults-boundExpansion-button"
  >
    <div
      className={arrowContainerStyle('up', isExpanded)}
      data-testid="searchResults-arrowUp-button"
    >
      <Icon
        className={arrowIconStyle(isExpanded)}
        color={etiColors.grayScale[10]}
        id="chevron-down"
      />
    </div>
    <div
      className={boundExpansionButtonsLineStyle(isExpanded)}
      data-testid="searchResults-boundExpansion-line"
    />
    <div
      className={arrowContainerStyle(null, isExpanded)}
      data-testid="searchResults-arrowDown-button"
    >
      <Icon
        className={arrowIconStyle(isExpanded)}
        color={etiColors.grayScale[10]}
        id="chevron-down"
      />
    </div>
  </div>
);

TripDetailsExpansionButtons.propTypes = {
  isExpanded: PropTypes.bool,
  isVI: PropTypes.bool,
};

export default TripDetailsExpansionButtons;
